module.exports = {
  "loading-image": {
    "height": "32",
    "width": "32",
    "marginRight": "10"
  },
  "dof-btn": {
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center",
    "opacity": 1,
    "position": "relative",
    "overflow": "hidden"
  },
  "mask": {
    "position": "absolute",
    "top": "0",
    "right": "0",
    "bottom": "0",
    "left": "0",
    "backgroundColor:active": "rgba(255,255,255,0.1)"
  },
  "dof-btn-highlight-primary-default": {
    "backgroundColor": "#00a4f2",
    "backgroundColor:active": "#0093d9"
  },
  "dof-btn-highlight-primary-base": {
    "backgroundColor": "#e5f5fd",
    "backgroundColor:active": "#cddce3"
  },
  "dof-btn-highlight-primary-plain": {
    "backgroundColor": "#ffffff",
    "backgroundColor:active": "rgba(38,122,255,0.1)"
  },
  "dof-btn-highlight-purple-default": {
    "backgroundColor": "#995efc",
    "backgroundColor:active": "#8a54e3"
  },
  "dof-btn-highlight-purple-base": {
    "backgroundColor": "#eee6ff",
    "backgroundColor:active": "#d5cee5"
  },
  "dof-btn-highlight-purple-plain": {
    "backgroundColor": "#ffffff",
    "backgroundColor:active": "rgba(153,94,252,0.1)"
  },
  "dof-btn-highlight-slate-default": {
    "backgroundColor": "#6575ff",
    "backgroundColor:active": "#5b69e6"
  },
  "dof-btn-highlight-slate-base": {
    "backgroundColor": "#e6e8ff",
    "backgroundColor:active": "#ced0e5"
  },
  "dof-btn-highlight-slate-plain": {
    "backgroundColor": "#ffffff",
    "backgroundColor:active": "rgba(101,117,255,0.1)"
  },
  "dof-btn-highlight-aqua-default": {
    "backgroundColor": "#29c3ff",
    "backgroundColor:active": "#24afe6"
  },
  "dof-btn-highlight-aqua-base": {
    "backgroundColor": "#e6f8ff",
    "backgroundColor:active": "#cedee5"
  },
  "dof-btn-highlight-aqua-plain": {
    "backgroundColor": "#ffffff",
    "backgroundColor:active": "rgba(41,195,255,0.1)"
  },
  "dof-btn-highlight-turquoise-default": {
    "backgroundColor": "#00bdb2",
    "backgroundColor:active": "#00b7a5"
  },
  "dof-btn-highlight-turquoise-base": {
    "backgroundColor": "#e6fffd",
    "backgroundColor:active": "#cee5e3"
  },
  "dof-btn-highlight-turquoise-plain": {
    "backgroundColor": "#ffffff",
    "backgroundColor:active": "rgba(0,203,184,0.1)"
  },
  "dof-btn-highlight-yellow-default": {
    "backgroundColor": "#ffaa10",
    "backgroundColor:active": "#e5980e"
  },
  "dof-btn-highlight-yellow-base": {
    "backgroundColor": "#fff4e0",
    "backgroundColor:active": "#e5dbc9"
  },
  "dof-btn-highlight-yellow-plain": {
    "backgroundColor": "#ffffff",
    "backgroundColor:active": "rgba(255,170,16,0.1)"
  },
  "dof-btn-highlight-orange-default": {
    "backgroundColor": "#ffaa10",
    "backgroundColor:active": "#e67521"
  },
  "dof-btn-highlight-orange-base": {
    "backgroundColor": "#fff0e6",
    "backgroundColor:active": "#e5d7ce"
  },
  "dof-btn-highlight-orange-plain": {
    "backgroundColor": "#ffffff",
    "backgroundColor:active": "rgba(255,130,37,0.1)"
  },
  "dof-btn-highlight-tomato-default": {
    "backgroundColor": "#f56428",
    "backgroundColor:active": "#e65f44"
  },
  "dof-btn-highlight-tomato-base": {
    "backgroundColor": "#ffeae6",
    "backgroundColor:active": "#e6d3cf"
  },
  "dof-btn-highlight-tomato-plain": {
    "backgroundColor": "#ffffff",
    "backgroundColor:active": "rgba(255,106,76,0.1)"
  },
  "dof-btn-highlight-gray-default": {
    "backgroundColor": "#7c879b",
    "backgroundColor:active": "#6f798b"
  },
  "dof-btn-highlight-gray-base": {
    "backgroundColor": "#cfd7e6",
    "backgroundColor:active": "#b9c1ce"
  },
  "dof-btn-highlight-gray-plain": {
    "backgroundColor": "#ffffff",
    "backgroundColor:active": "rgba(124,135,155,0.1)"
  },
  "dof-btn-highlight-red-default": {
    "backgroundColor": "#e61e1e",
    "backgroundColor:active": "#ce1a1a"
  },
  "dof-btn-highlight-red-base": {
    "backgroundColor": "#ffd9cf"
  },
  "dof-btn-highlight-red-plain": {
    "backgroundColor": "#ffffff"
  },
  "dof-btn-highlight-brown-default": {
    "backgroundColor": "#86696b",
    "backgroundColor:active": "#785e60"
  },
  "dof-btn-highlight-colmo-default": {
    "backgroundColor": "#b35336",
    "backgroundColor:active": "#743d2a"
  },
  "dof-btn-highlight-colmo-base": {
    "backgroundColor": "#313237",
    "backgroundColor:active": "rgba(0,0,0,0.3)"
  },
  "dof-btn-highlight-colmo-plain": {
    "backgroundColor": "rgba(0,0,0,0)",
    "backgroundColor:active": "#636569"
  },
  "btn-text": {
    "fontFamily": "PingFangSC-Medium",
    "textOverflow": "ellipsis",
    "lines": 1
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-e24c8c6a!./~/weex-vue-loader/lib/selector.js?type=styles&index=1!./packages/dof-button/index.vue
// module id = 554
// module chunks = 0 1